var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBandcamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840.413 275.173",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544.232 109.468c-35.066 0-52.983 27.6-52.983 69.176 0 39.302 19.375 68.802 52.983 68.802 38.006 0 52.257-34.78 52.257-68.802-.027-35.523-17.935-69.176-52.268-69.176M451.058 6.282h41.652v99.783h.738c11.328-18.895 35.074-30.616 56.27-30.616 59.552 0 88.427 46.885 88.427 103.967 0 52.523-25.573 102.042-81.49 102.042-25.575 0-52.98-6.413-65.411-32.124h-.722v26.85h-39.468V6.29l.004-.006m340.71 139.863c-3.292-23.814-20.096-36.674-43.118-36.674-21.568 0-51.89 11.724-51.89 71.07 0 32.511 13.88 66.916 50.062 66.916 24.112 0 40.914-16.653 44.946-44.626h41.65c-7.677 50.652-37.997 78.626-86.596 78.626-59.198 0-91.716-43.46-91.716-100.916 0-58.964 31.06-105.08 93.178-105.08 43.845 0 81.126 22.676 85.134 70.684h-41.65",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.673 265.658H21.92L153.96 21.92h282.758L304.673 265.66",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30.997619999999998
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandcamp);
export default __webpack_public_path__ + "static/media/Bandcamp.ce4489f9.svg";
export { ForwardRef as ReactComponent };